import { render, staticRenderFns } from "./RecipientInfo.vue?vue&type=template&id=b71c9eac&scoped=true"
import script from "./RecipientInfo.vue?vue&type=script&lang=js"
export * from "./RecipientInfo.vue?vue&type=script&lang=js"
import style0 from "./RecipientInfo.vue?vue&type=style&index=0&id=b71c9eac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b71c9eac",
  null
  
)

export default component.exports